import { useEffect, useState } from 'react';
import { config } from '../util/config';

const useWiki = pageid => {
  const [html, setHtml] = useState("");
  const [loading, setLoading] = useState(false);
  const [lastFetched, setLastFetched] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    setLastFetched("");
    setError(null);

    if (pageid != null) {
      const controller = new AbortController();

      const params = new URLSearchParams({
        'action': 'parse',
        'format': 'json',
        'pageid': pageid,
        'prop': 'text',
        'formatversion': 2,
        'redirects': 1,
        'disablelimitreport': 1,
        'parser': 'parsoid',
        'origin': '*',
      })

      setLoading(true);
      fetch(config.WIKI_API_URL + '?' + params, { signal: controller.signal })
        .then(res => res.json())
        .then(data => {
          const title = `<h1 id="firstHeading" class="firstHeading mw-first-heading"><span class="mw-page-title-main">${data.parse.title}</span></h1>`
          setHtml(title + data.parse.text);
          setLoading(false);
          setLastFetched(pageid);
        })
        .catch(err => {
          if (err.name !== 'AbortError') {
            console.error('Error fetching wiki page:', err);
            setError(err);
            setLoading(false);
          }
        })

      return () => controller.abort();
    }
    else {
      setHtml("");
      setLoading(false);
    }
  }, [pageid]);

  const isStale = lastFetched !== pageid;
  return { html, isStale, loading, error };
}

export default useWiki;
